/** 构建他人资料页路由（一级 params.userId） */
export function buildUserProfileRoute({ userId, from } = {}) {
  const uid = String(userId ?? '').trim();
  if (!uid) return null;
  const query = {};
  if (from) query.from = from;
  return {
    name: 'UserProfile',
    params: { userId: uid },
    ...(Object.keys(query).length ? { query } : {}),
  };
}
